export default {
    InternalOrderList: {
        information: '查看退货物流信息',
        number: '序号',
        company: '物流公司',
        document: '物流单号',
        Operation: '操作',
    },
};
